
export const popover = (target) => {
	const popover = document.querySelector(target);
	if (popover !== 'null' && typeof UIkit.modal(target) !== 'undefined') {
		UIkit.modal(target).show();
	}
}
